import Vue from 'vue';
import lottie from 'lottie-web';
import gsap from 'gsap';

import wordloop from '../lottie/word-setup.json';

Vue.component('footer-component', {
    data() {
        return {
            animation: null,
            // footerProxy: null,
            footerDimensions: null,
        };
    },

    mounted() {
        Vue.nextTick(() => {
            this.footerProxy = document.querySelector('#fixed-footer');
            this.updateFooter();

            window.addEventListener('resize', this.updateFooter());

            this.animation = lottie.loadAnimation({
                container: this.$refs.lottie,
                renderer: 'svg',
                autoplay: false,
                loop: false,
                animationData: wordloop,
            });

            this.timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: '.about__container',
                    start: 'bottom bottom',
                    end: this.footerDimensions ? `+=${this.footerDimensions.height}` : 'bottom top',
                    scrub: true,
                    onEnter: () => {
                        this.animation.goToAndPlay(0);
                    },
                },
            });

            this.timeline.to(['.about__footer-graphic', '.about__footer-content'], {
                y: 0,
            });

            // this.timeline.to('.footer__overlay', {
            //     opacity: 0,
            // }, '<');
        });
    },

    beforeDestroy() {
        this.timeline.scrollTrigger.kill();
        this.timeline.scrollTrigger = null;
        this.animation.destroy();
        window.removeEventListener('resize', this.updateFooter);
    },

    methods: {
        updateFooter() {
            this.footerDimensions = document.querySelector('footer').getBoundingClientRect();
            gsap.set(this.footerProxy, {
                height: this.footerDimensions.height,
            });
        },
    },
});
